import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

import { QuoteRequestRoutingModule } from './quote-request-routing.module';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { QuoteDescriptionsPicturesComponent } from './quote-descriptions-pictures/quote-descriptions-pictures.component';
import { QuoteGoodsInfoComponent } from './quote-goods-info/quote-goods-info.component';
import { QuoteLogisticsExtraServiceComponent } from './quote-logistics-extra-service/quote-logistics-extra-service.component';
import { QuoteLogisticsServiceInfoComponent } from './quote-logistics-service-info/quote-logistics-service-info.component';
import { QuoteRequestComponent } from './quote-request.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MaterialPersianDateAdapter, PERSIAN_DATE_FORMATS } from '@shared/material/material.persian-date.adapte';
import { MatCardModule } from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SharedModule } from '@shared/shared.module';


@NgModule({
  declarations: [
    QuoteRequestComponent,
    QuoteDescriptionsPicturesComponent,
    QuoteGoodsInfoComponent,
    QuoteLogisticsExtraServiceComponent,
    QuoteLogisticsServiceInfoComponent
  ],
  imports: [
    CommonModule,
    QuoteRequestRoutingModule,
    MatStepperModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  providers: [
    TitleCasePipe,
    MatStepperModule,
    {
      provide: DateAdapter,
      useClass: MaterialPersianDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS, useValue: PERSIAN_DATE_FORMATS
    },
  ]
})
export class QuoteRequestModule { }
